import { useEffect, useState } from 'react'
import { msUntilNextUTCMidnight } from '../game/daily'
import { useLang } from '../i18n/LangContext'

function format(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000))
  const h = Math.floor(total / 3600)
  const m = Math.floor((total % 3600) / 60)
  const s = total % 60
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${pad(h)}:${pad(m)}:${pad(s)}`
}

/** Live countdown to the next puzzle at 00:00 UTC. */
export function Countdown() {
  const { t } = useLang()
  const [ms, setMs] = useState(() => msUntilNextUTCMidnight())

  useEffect(() => {
    const id = setInterval(() => setMs(msUntilNextUTCMidnight()), 1000)
    return () => clearInterval(id)
  }, [])

  return (
    <span className="countdown">
      {t.nextPuzzle} <b>{format(ms)}</b>
    </span>
  )
}
